import React from "react";
import axios from "axios";
import { notifications } from '@mantine/notifications';
import { Group, Text, Loader, Select, Divider, Box } from '@mantine/core';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_TWO, BE_API_ONE, utils } from "../../utils/globalVariables";

import ModalResponse from "../../components/general/ModalResponse";
import ModalTakeAction from "../../components/general/ModalTakeAction";
import InputWrapperCustom from "../../components/general/InputWrapperCustom";
import BarangFormCekDetil from "./BarangFormCekDetil";

const BarangFormCek = ({ stateData, fnOnChangeMaster, fnOnChangeDetil, fnUpdateDetil }) => {

    const mountedRef = React.useRef(true);
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const notificationId = React.useRef({
        errorSubmitData: 'barangFormCek-1',
        errorUpdateData: 'barangFormCek-2',
    })

    const [data, setData] = React.useState({
        submitLoading: false,

        updateLoading: false,

        updateConfirmModal: false,

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const submitData = (value) => {
        setData(d => ({
            ...d,
            submitLoading: true,
        }))

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('project_id', stateData.projectId);
        formDT.append('project_process', stateData.projectProcess);
        formDT.append('project_is_cancel', stateData.projectIsCancel);
        formDT.append('project_form_cek_id', value);

        axios({
            method: 'post',
            url: BE_API_TWO + '/edit_project_barang_form_cek',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, submitLoading: false }));

            if (response.data.flag_status === 'isset') {
                fnOnChangeMaster(response.data.barang_form_cek_id, response.data.barang_form_cek_detil);
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorSubmitData,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'no-data') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({
                ...d,
                submitLoading: false
            }))

            notifications.show({
                id: notificationId.current.errorSubmitData,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }

    const updateFormCekDetil = () => {
        if (!stateData.data.value.masterId) {
            return false;
        }

        setData(d => ({ ...d, updateLoading: true }))

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('project_id', stateData.projectId);
        formDT.append('project_process', stateData.projectProcess);
        formDT.append('project_is_cancel', stateData.projectIsCancel);
        formDT.append('project_form_cek_id', stateData.data.value.masterId);

        axios({
            method: 'post',
            url: BE_API_ONE + '/update_trx_form_cek_detil',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, updateLoading: false }));

            if (response.data.flag_status === 'isset') {
                setData(d => ({ ...d, updateConfirmModal: false }))
                fnUpdateDetil(response.data.barang_form_cek_detil);
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorUpdateData,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'no-data-master') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, updateLoading: false }))

            notifications.show({
                id: notificationId.current.errorUpdateData,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }

    return (
        <React.Fragment>
            <InputWrapperCustom
                stateLabel={
                    <Group position="apart" noWrap mb='1rem'>
                        <Group>
                            <Text>{stateData.data.label}</Text>
                            {data.submitLoading && <Loader size="xs" />}
                        </Group>

                        {stateData.data.value.masterId &&
                            <Text
                                fw='normal'
                                sx={(tema) => ({
                                    color: tema.colorScheme === 'light' ? tema.colors.blue[7] : tema.colors.blue[4],
                                    cursor: 'pointer',
                                    userSelect: 'none'
                                })}

                                onClick={() => {
                                    setData(d => ({ ...d, updateConfirmModal: true }))
                                }}
                            >
                                Update
                            </Text>
                        }
                    </Group>
                }
                stateLabelFullWidth={true}
                stateWithAsterisk={stateData.data.withAsterisk}
                stateError={stateData.data.error}
                stateDescription={stateData.data.description}
            >
                <Select
                    value={stateData.data.value.masterId}
                    onChange={(val) => submitData(val)}
                    data={[
                        { value: '', label: 'Pilih Form Cek' },
                        ...stateData.dataBarangFormCek.map(key => ({ value: key.barang_form_cek_id, label: key.barang_form_cek_name }))
                    ]}

                    styles={(tema) => ({
                        input: {
                            backgroundColor: tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[7]
                        }
                    })}
                />
            </InputWrapperCustom>

            <Box
                mt={(Array.isArray(stateData.data.value.detil) && stateData.data.value.detil.length > 0) ? 'xl' : 0}
            >
                {(Array.isArray(stateData.data.value.detil) && stateData.data.value.detil.length > 0) && Object.keys(stateData.data.value.detil).map((key, index) => {
                    return (
                        <Box
                            key={key}
                            mt='md'
                        >
                            <BarangFormCekDetil
                                stateData={stateData.data.value.detil[key]}
                                stateDataProject={{
                                    projectId: stateData.projectId,
                                    projectProcess: stateData.projectProcess,
                                    projectIsCancel: stateData.projectIsCancel,
                                    projectFormCekMasterId: stateData.data.value.masterId,
                                    userAccess: stateData.userAccess
                                }}
                                fnOnChange={(ValueArray) => fnOnChangeDetil(ValueArray)}
                            />

                            {(Number(index) + 1) !== stateData.data.value.detil.length && <Divider mt='md' />}
                        </Box>
                    )
                })}
            </Box>

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />

            <ModalTakeAction
                stateShow={data.updateConfirmModal}
                fnHide={() => setData(d => ({ ...d, updateConfirmModal: false }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Confirmation').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Update'
                stateButtonActionPx='xs'
                stateButtonActionColor="red"
                stateButtonActionLoading={data.updateLoading}
                fnButtonAction={updateFormCekDetil}
            >
                <Text size='sm'>
                    Detil form dibawah ini akan diupdate sesuai dengan data pada master form cek detil.
                </Text>

                <Text size='sm' color="dimmed" mt='sm'>
                    - Jika data di master bertambah, detil item pada form ini akan ikut bertambah.
                </Text>

                <Text size='sm' color="dimmed" mt='sm'>
                    - Jika data di master berkurang, detil item pada form ini akan ikut berkurang.
                </Text>

                <Text size='sm' color="dimmed" mt='sm'>
                    - Jika data nama di master berubah, nama detil item pada form ini akan ikut diubah.
                </Text>
            </ModalTakeAction>
        </React.Fragment>
    )
}

export default BarangFormCek;